export { processAxiosConfig, getLovPara } from 'choerodon-ui/dataset';
